module.exports = __webpack_public_path__ + "img/premium-offer-mobile.51c1f5d2.png";